import React, { Fragment, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';

import Header from 'components/Header';
import Footer from 'components/Footer';
import User from 'components/Icons/User';
import { Grid, Column } from 'components/Layout';

import { checkPreviousAction } from 'actions/workflow';

import style from './style.scss';

const Blocked = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const workflow = useSelector((state) => state.workflow);

  useEffect(() => {
    const key = searchParams.get('key');
    if (key) {
      !get(workflow, 'data') && dispatch(checkPreviousAction({
        data: {},
        url: `/workflows/fsl/${key}/checkin`,
        success: (response) => {
          const routeUrl = response.data && response.data.url;
          navigate(routeUrl);
        },
        fail: () => {
          navigate('/fsl/application', { replace: true });
        },
      }));
    } else {
      navigate('/fsl/application');
    }
  }, [window.location.search]);

  return (
    <Fragment>
      <Header />
      <section className={cn('grid-container fluid section', style['borrowers-apply'])}>
        <div className="grid-container fluid borrowers-message">
          <div className="grid-container">
            <Grid className="grid-margin-x max-limited">

              <Column className="small-12 large-6 large-offset-3">
                <User width={80} className={style.user} />
                <h2>Unfortunately, we were unable to approve your application at this time.</h2>
              </Column>

            </Grid>
          </div>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};

export default Blocked;
